import * as ActionTypes from '../ActionTypes';

const initialState = {
    workLocation_options: [],
    isLoading: false,
    workLocationAccess_options: [],
    isLocationLoad: false,
    isAdding: false,
    isGetting: false
};

const WorkLocationReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.WORK_LOCATION_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                isSuccess:false,
                error: false,
                isGetting: true
            };
        case ActionTypes.WORK_LOCATION_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                isSuccess:true,
                isGetting: false,
                error: action.payload.has_error,
                workLocation_options: action.payload?.data?.data
            };
        case ActionTypes.WORK_LOCATION_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                isSuccess:false,
                error: false,
                isAdding: true
            };
        case ActionTypes.WORK_LOCATION_ADD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                isSuccess:true,
                isAdding: false,
                error: action.payload.has_error,
                workLocation_options: action.payload?.data?.data
            };
        case ActionTypes.WORK_LOCATION_ADD_ERROR:
            return {
                ...state,
                isLoading: false,
                isAdding: false,
                error: action.payload.has_error,
            };
        case ActionTypes.WORK_LOCATION_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false
            };
        case ActionTypes.WORK_LOCATION_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                error: action.payload.has_error,
                workLocation_options: action.payload?.data?.data
            };
        case ActionTypes.WORK_LOCATION_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload.has_error,
            };
        case ActionTypes.WORK_LOCATION_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false
            };
        case ActionTypes.WORK_LOCATION_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                error: action.payload.has_error,
                workLocation_options: action.payload?.data?.data
            };
        case ActionTypes.WORK_LOCATION_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload.has_error,
            };
        case ActionTypes.USER_WORK_LOCATION_GET_REQUEST:
            return {
                ...state,
                isLocationLoad: true,
               
            };
        case ActionTypes.USER_WORK_LOCATION_GET_SUCCESS:
            return {
                ...state,
                isLocationLoad: false,
                workLocationAccess_options: action.payload?.data?.data
            };
        case ActionTypes.USER_WORK_LOCATION_GET_ERROR:
            return {
                ...state,
                isLocationLoad: false,
                error: action.payload.has_error,
            };
        default:
            return state;
    }
}

export default WorkLocationReducer;